import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as UiProvider } from "./components/ui/provider";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <UiProvider>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </UiProvider>
  </Provider>
);
